import { useEffect } from 'react';

const useUpdateTitle = (unreadCount: number, pageKey?: string) => {
    useEffect(() => {
        // DynamicTitle updates the route title before child effects run. Read it
        // here instead of capturing the login title during the header's render.
        const baseTitle = document.title.replace(/^\(\d+\)\s*/, '');

        if (unreadCount > 0) {
            document.title = `(${unreadCount}) ${baseTitle}`;
        } else {
            document.title = baseTitle;
        }
    }, [pageKey, unreadCount]);
};

export default useUpdateTitle;
